import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  allAlertTypesByModule: [],
}

const getters = {
  allAlertTypesByModule({ analyticModuleId, admin }) {
    let url = `/AlertType?filterBy=analyticModule&filterById=${analyticModuleId}`
    if (admin) {
      url += '&isAnalyticAdmin=true'
    }
    return axios.get(url)
  },
}

const saves = {
  saveAlertType(alert) {
    const url = `/AlertType/${alert.id}`
    return axios.put(url, alert)
  },
}

export default class AlertTypeService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
